// dependencies
import { fromJS } from "immutable";

const baseAction = "FIELDS";

export function ParseFields(fieldList) {
	return (dispatch) => {
		const fieldMap = {};

		fieldList.forEach((fieldObject) => {
			fieldMap[fieldObject._id] = fieldObject;
		});

		dispatch({
			type: `${baseAction}:SET_FIELDS`,
			fieldMap: fromJS(fieldMap),
		});
	};
}
